
import { useState, useEffect } from 'react';
import { Creative, Location } from '../types';

interface UseContentStepProps {
  creatives: Creative[];
  locationCreatives: Record<string, Creative[]>;
  mediaOwnerCreatives: Record<string, Creative[]>;
  selectedLocations: Location[];
  useLocationSpecificCreatives: boolean;
  useMediaOwnerSpecificCreatives: boolean;
  onToggleMediaOwnerSpecificCreatives: (value: boolean) => void;
  campaignName: string;
}

export const useContentStep = ({
  creatives,
  locationCreatives,
  mediaOwnerCreatives,
  selectedLocations,
  useMediaOwnerSpecificCreatives,
  onToggleMediaOwnerSpecificCreatives,
  campaignName
}: UseContentStepProps) => {
  const [uniqueMediaOwners, setUniqueMediaOwners] = useState<string[]>([]);

  // Set media owner specific creatives to be enabled by default without showing toggle
  useEffect(() => {
    if (!useMediaOwnerSpecificCreatives) {
      onToggleMediaOwnerSpecificCreatives(true);
    }
  }, [useMediaOwnerSpecificCreatives, onToggleMediaOwnerSpecificCreatives]);

  // Extract unique media owners from selected locations
  useEffect(() => {
    if (selectedLocations && selectedLocations.length > 0) {
      const mediaOwners = new Set<string>();
      selectedLocations.forEach(location => {
        if (location.mediaOwner) {
          mediaOwners.add(location.mediaOwner);
        }
      });
      setUniqueMediaOwners(Array.from(mediaOwners));
    } else {
      setUniqueMediaOwners([]);
    }
  }, [selectedLocations]);

  return {
    uniqueMediaOwners
  };
};
